export const SaveQuoteLog = (quote, setLoading, setMessage, setQuoteSaved, saveMessage) => {
    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

    fetch(`${covrServicesUrl}/api/SaveQuote/CreateSavedQuote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(quote),
      })
        .then((res) => res.json())
        .then((data) => {
            setLoading(false);
            if (data){
                setMessage({status:'success', message: saveMessage.success.message});
                setQuoteSaved(true);
            }
            else {
                setMessage({status:'error', message: 'Could not save your email address. Please try again'});
                setQuoteSaved(false);
            }
        })
        .catch((error) => {
           setLoading(false);
           setMessage({status:'error', message: 'Could not save your email address. Please try again'});
           setQuoteSaved(false);
        })
        .finally(() => {
          setLoading(false);
        });
}